import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Copy, Check } from 'lucide-react';

const GoogleDriveImageHelper = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const exampleUrl = 'https://drive.google.com/uc?id=FILE_ID_HERE&export=download';

  const handleCopy = () => {
    navigator.clipboard.writeText(exampleUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div style={{
      background: '#f0f9ff',
      border: '1px solid #bfdbfe',
      borderRadius: '0.375rem',
      marginBottom: '1.5rem'
    }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justify: 'space-between',
          padding: '1rem',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#1e40af',
          fontWeight: '600',
          fontSize: '0.95rem'
        }}
      >
        <span>💡 How to use Google Drive images</span>
        {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>

      {isOpen && (
        <div style={{
          padding: '0 1rem 1rem 1rem',
          borderTop: '1px solid #bfdbfe',
          color: '#1e3a8a',
          fontSize: '0.9rem',
          lineHeight: '1.6'
        }}>
          <ol style={{ marginTop: '1rem', paddingLeft: '1.5rem' }}>
            <li style={{ marginBottom: '0.75rem' }}>
              <strong>Upload image to Google Drive</strong> and right-click to get the shareable link
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              <strong>Open the link</strong> and copy the file ID from the URL (the long string after <code style={{ background: '#dbeafe', padding: '0 0.25rem' }}>/d/</code>)
            </li>
            <li style={{ marginBottom: '0.75rem' }}>
              <strong>Use this format</strong> for image URLs in the featured image field or in the editor:
            </li>
          </ol>

          <div style={{
            background: '#dbeafe',
            padding: '1rem',
            borderRadius: '0.375rem',
            marginTop: '1rem',
            marginBottom: '1rem',
            fontFamily: 'monospace',
            fontSize: '0.85rem',
            wordBreak: 'break-all',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '1rem'
          }}>
            <code>{exampleUrl}</code>
            <button
              onClick={handleCopy}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 0.75rem',
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.25rem',
                cursor: 'pointer',
                fontSize: '0.85rem',
                fontWeight: '600',
                whiteSpace: 'nowrap'
              }}
            >
              {copied ? (
                <>
                  <Check size={14} /> Copied
                </>
              ) : (
                <>
                  <Copy size={14} /> Copy
                </>
              )}
            </button>
          </div>

          <p style={{ marginBottom: '0.75rem' }}>
            <strong>Example:</strong>
          </p>
          <p style={{ fontFamily: 'monospace', fontSize: '0.85rem', background: '#dbeafe', padding: '0.5rem', borderRadius: '0.25rem', marginBottom: '1rem' }}>
            https://drive.google.com/uc?id=1a2b3c4d5e6f7g8h9i0j1k2l3m4n5o6p&export=download
          </p>

          <p style={{ marginTop: '0.75rem' }}>
            <strong>To insert images in the editor:</strong>
          </p>
          <ol style={{ paddingLeft: '1.5rem' }}>
            <li>Click the image button in the editor toolbar</li>
            <li>Paste the Google Drive URL in the image URL field</li>
            <li>The image will be embedded in your post</li>
          </ol>

          <div style={{
            background: '#fef3c7',
            border: '1px solid #fcd34d',
            borderRadius: '0.375rem',
            padding: '0.75rem',
            marginTop: '1rem',
            fontSize: '0.85rem'
          }}>
            ⚠️ <strong>Note:</strong> Make sure the Google Drive file is shared publicly or with "Anyone with the link" permission, otherwise images won't load.
          </div>
        </div>
      )}
    </div>
  );
};

export default GoogleDriveImageHelper;
